import React from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import Visualizer from "./Visualizer";
import createBrowserHistory from "history/createBrowserHistory";
import "./App.css";

const Configuration = require("./shared/configuration");

const App = () => {
  const customHistory = createBrowserHistory();

  return (
    <div className="App">
      <Router history={customHistory}>
        <Switch>
          <Redirect exact from="/" to="en/left/classic/basic/sign/a4" />
          {Configuration.endPoints.map(path => (
            <Route exact key="router" path={path} component={Visualizer} />
          ))}
        </Switch>
      </Router>
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js